import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import NadaConsta from "../../../components/nadaConsta";

export default function Apontamentos({
  apontamentos,
  isConsultaNova,
}: {
  apontamentos: any;
  isConsultaNova?: boolean;
}) {
  const { t } = useTranslation();

  const formatDate = (value: { toLocaleDateString: (arg0: string, arg1: { day: string; month: string; year: string }) => any }) => {
    return value.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const getLastOccurrence = () => {
    let data: Date | null = null;
    if (!apontamentos) return data;
    apontamentos.forEach((element: { dataRegistro: string }) => {
      const [dia, mes, ano] = element.dataRegistro.split(/[\/: ]/).map(v => parseInt(v));
      const dataFormatada = new Date(ano, mes - 1, dia);
      if (data == null || data < dataFormatada) data = dataFormatada;
    });
    return data ? formatDate(data) : '';
  };

  const getTotal = () => {
    let total: GLfloat = 0.0;
    if (!apontamentos) return total;
    apontamentos.forEach((element: { valor: string }) => {
      total = total + parseFloat(element.valor.replaceAll('.', '').replace(',', '.'));
    });
    return total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
  };

  const hasApontamentos = apontamentos && apontamentos.length > 0;

  if (isConsultaNova) {
    return (
      <div
        style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          border: '1px solid #E5E7EB',
          boxShadow: '0 4px 20px -2px rgba(0,0,0,0.05)',
          padding: '24px',
        }}
      >
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
          <div
            style={{
              backgroundColor: hasApontamentos ? '#FEF2F2' : '#F0FDF4',
              borderRadius: '10px',
              padding: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <i
              className={hasApontamentos ? 'pi pi-exclamation-triangle' : 'pi pi-check-circle'}
              style={{ color: hasApontamentos ? '#DC2626' : '#16A34A', fontSize: '18px' }}
            />
          </div>
          <div>
            <h3 style={{ fontSize: '1rem', fontWeight: 700, margin: 0, color: '#1E3A8A' }}>
              {t('apontamentos')}
            </h3>
            {hasApontamentos && (
              <span style={{ fontSize: 'small', color: '#6B7280' }}>
                {apontamentos.length} apontamento{apontamentos.length !== 1 ? 's' : ''} encontrado{apontamentos.length !== 1 ? 's' : ''}
              </span>
            )}
          </div>
        </div>

        {!hasApontamentos ? (
          <NadaConsta />
        ) : (
          <>
            {/* Summary cards */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
                gap: '12px',
                marginBottom: '20px',
              }}
            >
              {[
                { label: 'Valor Total', value: getTotal(), icon: 'pi pi-dollar', color: '#DC2626', bg: '#FEF2F2', border: '#FECACA' },
                { label: 'Quantidade', value: apontamentos.length, icon: 'pi pi-list', color: '#D97706', bg: '#FFF7ED', border: '#FED7AA' },
                { label: 'Última Ocorrência', value: getLastOccurrence() || '—', icon: 'pi pi-calendar', color: '#2563EB', bg: '#EFF6FF', border: '#BFDBFE' },
              ].map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    backgroundColor: item.bg,
                    border: `1px solid ${item.border}`,
                    borderRadius: '12px',
                    padding: '14px 16px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <i className={item.icon} style={{ color: item.color, fontSize: '13px' }} />
                    <span style={{ fontSize: '0.7rem', fontWeight: 700, color: item.color, textTransform: 'uppercase' }}>
                      {item.label}
                    </span>
                  </div>
                  <span style={{ fontSize: '1rem', fontWeight: 800, color: '#1F2937' }}>{item.value}</span>
                </div>
              ))}
            </div>

            {/* Table */}
            <div style={{ overflowX: 'auto', borderRadius: '10px', border: '1px solid #F3F4F6' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: 'small' }}>
                <thead>
                  <tr style={{ backgroundColor: '#F9FAFB', borderBottom: '2px solid #E5E7EB' }}>
                    {[t('dataRegistro'), t('dataVencimento'), t('natureza'), t('contrato'), t('credor'), t('tipo'), t('valor')].map(h => (
                      <th key={h} style={{ padding: '10px 14px', fontWeight: 700, color: '#6B7280', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.05em', whiteSpace: 'nowrap' }}>
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {apontamentos.map((a: any, idx: number) => (
                    <tr
                      key={idx}
                      style={{ borderBottom: idx < apontamentos.length - 1 ? '1px solid #F3F4F6' : 'none' }}
                      onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#FEF2F2')}
                      onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'transparent')}
                    >
                      <td style={{ padding: '10px 14px', color: '#374151' }}>{a.dataRegistro}</td>
                      <td style={{ padding: '10px 14px', color: '#374151' }}>{a.dataVencimento}</td>
                      <td style={{ padding: '10px 14px', color: '#374151' }}>{a.natureza}</td>
                      <td style={{ padding: '10px 14px', color: '#374151' }}>{a.contrato}</td>
                      <td style={{ padding: '10px 14px', color: '#374151', fontWeight: 600 }}>{a.nomeCredor}</td>
                      <td style={{ padding: '10px 14px' }}>
                        <span style={{ backgroundColor: '#F3F4F6', color: '#374151', fontSize: '0.7rem', fontWeight: 700, padding: '2px 8px', borderRadius: '4px' }}>
                          {a.tipo}
                        </span>
                      </td>
                      <td style={{ padding: '10px 14px', fontWeight: 700, color: '#DC2626' }}>{a.valor}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    );
  }

  // Legacy layout
  const headerTemplate = (options: any) => {
    const className = `${options.className} `;
    return (
      <div className={className}>
        {hasApontamentos ? (
          <span style={{ color: '#C70039', fontSize: '1.5rem' }} className="pi pi-exclamation-triangle">
            <span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color: 'black' }}>
              {t('apontamentos')}
            </span>
          </span>
        ) : (
          <span className="p-panel-title" style={{ marginLeft: '1rem', fontFamily: 'var(--font-family)', fontSize: '1rem', color: 'black' }}>
            {t('apontamentos')}
          </span>
        )}
      </div>
    );
  };

  return (
    <Panel headerTemplate={headerTemplate}>
      {!hasApontamentos ? (
        <NadaConsta />
      ) : (
        <>
          <div style={{ paddingBottom: '2rem', paddingLeft: '5rem' }}>
            <span style={{ padding: '2rem' }}><b>VALOR TOTAL:</b> {getTotal()} </span>
            <span style={{ padding: '2rem' }}><b>QUANTIDADE DE PENDÊNCIAS HOJE:</b> {apontamentos.length} </span>
            <span style={{ padding: '2rem' }}><b>ÚLTIMA OCORRÊNCIA:</b> {getLastOccurrence()} </span>
          </div>
          <DataTable size="small" value={apontamentos} tableStyle={{ minWidth: '50rem' }}>
            <Column field="dataRegistro" header={t('dataRegistro')}></Column>
            <Column field="dataVencimento" header={t('dataVencimento')}></Column>
            <Column field="natureza" header={t('natureza')}></Column>
            <Column field="contrato" header={t('contrato')}></Column>
            <Column field="cnpjCredor" header={t('cnpjCredor')}></Column>
            <Column field="nomeCredor" header={t('credor')}></Column>
            <Column field="cidadeUF" header={t('cidadeUF')}></Column>
            <Column field="tipo" header={t('tipo')}></Column>
            <Column field="valor" header={t('valor')}></Column>
          </DataTable>
        </>
      )}
    </Panel>
  );
}
